import { useAuth0 } from "@auth0/auth0-react";
import { TrainingAPI } from "@api/TrainingAPI";
import { audioMessage as message } from "@components/Common/Notifications/audioMessage";
import { Button, Typography, Alert, Input, Popconfirm } from "antd";
import { useState } from "react";
import { isStaffEmail } from "@utils/user_utils";

const { Text } = Typography;

export const GraphicsPackageDownloader = () => {
    const {user} = useAuth0();
    const trainingAPI = new TrainingAPI();
    const [loading, setLoading] = useState(false);
    const [tempLoading, setTempLoading] = useState(false);
    const [opponents, setOpponents] = useState("Chelsea, Arsenal, West Ham, Liverpool");

    if (!isStaffEmail(user?.email)) {
        return <></>;
    }

    const handleDownload = async () => {
        setLoading(true);
        await trainingAPI.getGraphicsPackage()
            .then(() => { message.success("Report downloaded successfully"); })
            .catch(() => { message.error("Failed to download report"); });
        setLoading(false);
    };

    const handleSampleWeeklyReport = async () => {
        setTempLoading(true);
        await trainingAPI.performCustomAction({ action: 'gen_dummy_weekly_report', opponents })
            .then((resp) => { message.info(resp); })
            .catch(() => { message.error("Error"); });
        setTempLoading(false);
    };

    return (
        <div>
        <Alert 
            type={"warning"}
            showIcon
            style={{width: '80%'}}
            description={"You can only see this option if you are logged in with a whistle staff account."}
        />

        <Button
            onClick={handleDownload}
            loading={loading}
            style={{
                width: "80%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "20px 0"
                }}
            type="primary"
        >
            Download Graphics Package
        </Button>

            <Popconfirm
                title={<>
                    Generate a sample report? <br /><br />
                    Opponents (Type 4): <Input
                        size="small"
                        placeholder="e.g. Chelsea, Arsenal"
                        value={opponents}
                        onChange={(e) => setOpponents(e.target.value)}
                    />
                </>}
                okText="Yes"
                cancelText="No"
                onConfirm={handleSampleWeeklyReport}
                onCancel={null}
            >
                <Button
                    loading={tempLoading}
                    style={{
                        width: "80%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                    type="primary"
                >
                    Gen Sample Weekly Report with current Team Colors
                </Button>
            </Popconfirm>
        </div>
    );
};
